import { Base } from "../../framework/base";
import { EditItem, IEditItem } from "../common/editItem";
import { FileAttachment, IFileAttachment } from "../common/fileAttachment";
import { WhistleBlowResolution, WhistleBlowSeverity, WhistleBlowSource, WhistleBlowState, WhistleBlowArchiveState } from "../enums";
import { IModifyUser, ModifyUser } from "../user/modifyUser";
import { IWhistleBlowEditItemMessage, WhistleBlowEditItemMessage } from "./whistleBlowEditItemMessage";

export interface IWhistleBlowEditItem extends IEditItem {
    channelId: string;
    unitId: string;
    unitCode: string;
    categoryId: string;
    state: WhistleBlowState;
    archiveState: WhistleBlowArchiveState;
    severity: WhistleBlowSeverity;
    resolution: WhistleBlowResolution;
    resolutionComment: string;
    source: WhistleBlowSource;
    sourceComment: string;
    code: string;
    anonymous: boolean;
    title: string;
    date: number;
    description: string;
    informantName: string;
    informantEmail: string;
    informantPhone: string;
    informantPasswordConfirmed: boolean;
    createDate: number;
    resolvedDate: number;
    toBeReceivedDate: number;
    toBeReceivedDateUrgency: number;
    toBeRespondedDate: number;
    toBeRespondedDateUrgency: number;
    createdByInformant: boolean;
    modifyUser: IModifyUser;
    attachments: IFileAttachment[];
    messages: IWhistleBlowEditItemMessage[];
    handlers: IModifyUser[];
}

export class WhistleBlowEditItem extends EditItem implements IWhistleBlowEditItem {
    channelId: string;
    unitId: string;
    unitCode: string;
    categoryId: string;
    state: WhistleBlowState;
    archiveState: WhistleBlowArchiveState;
    severity: WhistleBlowSeverity;
    resolution: WhistleBlowResolution;
    resolutionComment: string;
    source: WhistleBlowSource;
    sourceComment: string;
    code: string;
    anonymous: boolean;
    title: string;
    date: number;
    description: string;
    informantName: string;
    informantEmail: string;
    informantPhone: string;
    informantPasswordConfirmed: boolean;
    createDate: number;
    resolvedDate: number;
    toBeReceivedDate: number;
    toBeReceivedDateUrgency: number;
    toBeRespondedDate: number;
    toBeRespondedDateUrgency: number;
    createdByInformant: boolean;
    modifyUser: ModifyUser;
    attachments: FileAttachment[];
    messages: WhistleBlowEditItemMessage[];
    handlers: ModifyUser[];

    constructor();
    constructor(obj: IWhistleBlowEditItem);
    constructor(obj?: any) {
        super(obj);
        this.channelId = obj && obj.channelId || "";
        this.unitId = obj && obj.unitId || "";
        this.unitCode = obj && obj.unitCode || "";
        this.categoryId = obj && obj.categoryId || "";
        this.state = obj && obj.state || WhistleBlowState.New;
        this.archiveState = obj && obj.archiveState || WhistleBlowArchiveState.NotArchived;
        this.severity = obj && obj.severity || WhistleBlowSeverity.Unspecified;
        this.resolution = obj && obj.resolution || WhistleBlowResolution.Unspecified;
        this.resolutionComment = obj && obj.resolutionComment || "";
        this.source = obj && obj.source || WhistleBlowSource.Unspecified;
        this.sourceComment = obj && obj.sourceComment || "";
        this.code = obj && obj.code || "";
        this.anonymous = obj && obj.anonymous || false;
        this.title = obj && obj.title || "";
        this.date = obj && obj.date || 0;
        this.description = obj && obj.description || "";
        this.informantName = obj && obj.informantName || "";
        this.informantEmail = obj && obj.informantEmail || "";
        this.informantPhone = obj && obj.informantPhone || "";
        this.informantPasswordConfirmed = obj && obj.informantPasswordConfirmed || false;
        this.createDate = obj && obj.createDate || 0;
        this.resolvedDate = obj && obj.resolvedDate || 0;
        this.toBeReceivedDate = obj && obj.toBeReceivedDate || 0;
        this.toBeReceivedDateUrgency = obj && obj.toBeReceivedDateUrgency || 0;
        this.toBeRespondedDate = obj && obj.toBeRespondedDate || 0;
        this.toBeRespondedDateUrgency = obj && obj.toBeRespondedDateUrgency || 0;
        this.createdByInformant = obj && obj.createdByInformant || false;
        this.modifyUser = new ModifyUser(obj?.modifyUser);
        this.attachments = Base.getTypedArray(obj?.attachments, FileAttachment);
        this.messages = Base.getTypedArray(obj?.messages, WhistleBlowEditItemMessage);
        this.handlers = ModifyUser.sortModifyUsers(Base.getTypedArray(obj?.handlers, ModifyUser));
        WhistleBlowEditItemMessage.sortWhistleBlowEditItemMessages(this.messages);
        FileAttachment.sortFileAttachments(this.attachments);
    }
}